import { AbstractPlugin } from 'mlb-media-player';

/**
 *
 * @module BaseAdvertisingPlugin
 * @desc
 * @class BaseAdvertisingPlugin
 *
 */
class BaseAdvertisingPlugin extends AbstractPlugin {

    constructor(config, observationCenter) {

        super(config, observationCenter);

        this.ready = false;
        this.adManager = null;
        this.adPlaying = false;
        this.pluginDidError = false;

    }

    requestAd(adVideoElement, adContainer) {

        this.adPlaying = false;

    }

    startMidRoll() {

        throw new Error('Implement startMidRoll()');

    }

    endMidRoll() {

        throw new Error('Implement endMidRoll()');

    }

    endPreRoll() {

        throw new Error('Implement endPreRoll()');

    }


    setClip() {

        throw new Error('Implement setClip()');

    }

    resumeAd() {

        throw new Error('Implement resumeAd()');

    }

    setSize(width, height, isFullScreen) {

        throw new Error('Implement setSize()');

    }

    setVolume(pct) {

        throw new Error('Implement setVolume()');

    }

    mute() {

        throw new Error('Implement mute()');

    }

    unmute() {

        throw new Error('Implement unmute()');

    }

    getCurrentTimeInSecs() {

        return 0;

    }

    getDurationInSecs() {

        return 0;

    }

    initializeForAutoPlayPermission(adVideoElement, adContainer) {

        throw new Error('Implement initializeForAutoPlayPermission(adVideoElement, adContainer)');

    }

    /**
     *
     * Utility function for returning the name of the class.
     * @return string The class type.
     *
     */
    toString() {

        return 'BaseAdvertisingPlugin';

    }

}

export default BaseAdvertisingPlugin;
